/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Flag } from 'ui/atoms/Flag/Flag';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import styles from './HomeRegistriesSection.module.scss';

const REGISTRIES: { code: string; name: string; country: string }[] = [
  { code: 'gb', name: 'Companies House', country: 'United Kingdom' },
  { code: 'de', name: 'Handelsregister', country: 'Germany' },
  { code: 'fr', name: 'Registre National des Entreprises', country: 'France' },
  { code: 'nl', name: 'Kamer van Koophandel', country: 'Netherlands' },
  { code: 'it', name: 'Registro delle Imprese', country: 'Italy' },
  { code: 'es', name: 'Registro Mercantil', country: 'Spain' },
  { code: 'be', name: 'Banque-Carrefour des Entreprises', country: 'Belgium' },
  { code: 'pl', name: 'Krajowy Rejestr Sądowy', country: 'Poland' },
  { code: 'ie', name: 'Companies Registration Office', country: 'Ireland' },
  { code: 'se', name: 'Bolagsverket', country: 'Sweden' },
  { code: 'dk', name: 'Erhvervsstyrelsen', country: 'Denmark' },
  { code: 'no', name: 'Brønnøysundregistrene', country: 'Norway' },
  { code: 'fi', name: 'Patentti- ja rekisterihallitus', country: 'Finland' },
  { code: 'at', name: 'Firmenbuch', country: 'Austria' },
  { code: 'ch', name: 'Zefix', country: 'Switzerland' },
  { code: 'cz', name: 'Obchodní rejstřík', country: 'Czechia' },
  { code: 'ro', name: 'Registrul Comerțului', country: 'Romania' },
  { code: 'lu', name: 'Registre de Commerce et des Sociétés', country: 'Luxembourg' },
  { code: 'jp', name: 'National Tax Agency', country: 'Japan' },
  { code: 'us', name: 'Secretaries of State', country: 'United States' },
];

type HomeRegistriesSectionProps = {
  title: string;
};

export const HomeRegistriesSection = ({ title }: HomeRegistriesSectionProps) => {
  const { t } = useInt();

  return (
    <section className={styles.section}>
      <div className={styles.glow} aria-hidden="true" />

      <div className={styles.inner}>
        <TitleBlock title={title} theme="dark" className={styles.titleBlock} />
      </div>

      <div className={styles.marquee}>
        <div className={styles.track} aria-hidden="true">
          {[...REGISTRIES, ...REGISTRIES].map((registry, i) => (
            <span key={`${registry.name}-${i}`} className={styles.item}>
              <Flag code={registry.code} className={styles.flag} />
              <span className={styles.name}>{registry.name}</span>
              <span className={styles.country}>{t(registry.country)}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
